export default __webpack_public_path__ + "static/media/work_ec-productConfirm.f8cd08ac.jpg";